module.exports = __webpack_public_path__ + "img/home_icon_xiangmuzixun.bea183db.svg";